import { render } from "./Season1Icon.vue?vue&type=template&id=a1fc8c82"
import script from "./Season1Icon.vue?vue&type=script&lang=js"
export * from "./Season1Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__